import { useEffect, useState } from "react";

export function usePagination(items, initialPerPage = 25, resetKey = "") {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(initialPerPage);
  const total = items.length;
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  useEffect(() => { setPage(1); }, [resetKey]);
  const current = Math.min(page, totalPages);
  const pageItems = items.slice((current - 1) * perPage, current * perPage);
  const changePerPage = (n) => { setPerPage(n); setPage(1); };
  return { page: current, setPage, totalPages, pageItems, total, perPage, changePerPage, from: total === 0 ? 0 : (current - 1) * perPage + 1, to: Math.min(current * perPage, total) };
}

function pageList(current, totalPages) {
  const pages = [...new Set([1, totalPages, current - 1, current, current + 1])].filter((p) => p >= 1 && p <= totalPages).sort((a, b) => a - b);
  const out = [];
  let prev = 0;
  for (const p of pages) {
    if (p - prev > 1) out.push("...");
    out.push(p);
    prev = p;
  }
  return out;
}

const PER_PAGE_OPTIONS = [25, 50, 100, 200];

export function Pagination({ pager, testid = "pagination" }) {
  const { page, setPage, totalPages, total, from, to, perPage, changePerPage } = pager;
  if (total === 0) return null;
  return (
    <div className="pagination-bar" data-testid={testid}>
      <div className="pagination-left">
        <span className="pagination-info" data-testid={`${testid}-info`}>Menampilkan {from}–{to} dari {total} data</span>
        <label className="per-page-select">
          Baris per halaman
          <select data-testid={`${testid}-per-page`} value={perPage} onChange={(e) => changePerPage(Number(e.target.value))}>
            {PER_PAGE_OPTIONS.map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
        </label>
      </div>
      {totalPages > 1 && (
        <div className="pagination-pages">
          <button data-testid={`${testid}-prev`} className="page-btn nav" disabled={page === 1} onClick={() => setPage(page - 1)}>← Sebelumnya</button>
          {pageList(page, totalPages).map((p, i) => p === "..." ? <span key={`e${i}`} className="page-ellipsis">…</span> : (
            <button key={p} data-testid={`${testid}-page-${p}`} className={`page-btn ${p === page ? "active" : ""}`} onClick={() => setPage(p)}>{p}</button>
          ))}
          <button data-testid={`${testid}-next`} className="page-btn nav" disabled={page === totalPages} onClick={() => setPage(page + 1)}>Berikutnya →</button>
        </div>
      )}
    </div>
  );
}
